import type { FreelancerCertificationInformationPageLocales } from '../types';

const freelancerCertificationInformationPageLocales: FreelancerCertificationInformationPageLocales =
  {
    addCertificate: 'Add certificate',
    certificateDeleted: 'Certificate deleted successfully!',
    confirmRemoveCertificate: 'Yes, remove certificate',
    continue: 'Continue',
    deleteCertificateMessage:
      'Are you sure you want to delete {{certificateName}}? If you make a mistake, you can manually add the certificate again.',
    helperMessage:
      'Add your certificates below. No certificates? Then you can skip this step.',
    removeCertificate: 'Remove certificate',
    skipStep: 'Skip step',
    title: 'Certificates',
    youWantToContinue: 'Are you sure you want to delete this file?',
  };

export default freelancerCertificationInformationPageLocales;
